/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Oauth_HintInputs */



/**
* | output |
* | --- |
* | "After saving you sign in to the server. Every call through this server acts as the account you sign in with." |
*
* @param {Mcp_Servers_Oauth_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_oauth_hint = /** @type {((inputs?: Mcp_Servers_Oauth_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Oauth_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach dem Speichern melden Sie sich beim Server an. Jeder Aufruf über diesen Server handelt mit dem Konto, mit dem Sie sich anmelden.")
	return /** @type {LocalizedString} */ ("After saving you sign in to the server. Every call through this server acts as the account you sign in with.")
});